import axios from 'axios'

export const apiURL = `https://newtail-media.newtail.com.br/v1/rma`
export const apiURLStaging = `https://staging.newtail-media.newtail.com.br/v1/rma`

export const apiNewtailRetailMedia = axios.create({
  baseURL: apiURL
})

export const apiNewtailRetailMediaStaging = axios.create({
  baseURL: apiURLStaging
})
